import { Link } from "wouter";
import { BrandLoader } from "@workspace/brand-react";
import { Seo } from "@/components/Seo";
import { Section } from "@/components/Section";

export default function NotFound() {
  return (
    <>
      <Seo title="Not found" description="The page you're looking for doesn't exist." path="/404" noindex />
      <Section className="!py-32 text-center">
        <div className="flex justify-center">
          <BrandLoader size="lg" label="Page not found" />
        </div>
        <div className="mt-8 font-mono text-sm text-[hsl(var(--brand-brass))]">404</div>
        <h1 className="mt-3 text-4xl font-semibold text-[hsl(var(--brand-charcoal))]">We couldn't find that page.</h1>
        <p className="mt-4 text-[hsl(var(--brand-slate))]">It may have moved, or the link may be wrong.</p>
        <Link href="/" className="mt-8 inline-block bg-[hsl(var(--brand-forest))] text-[hsl(var(--brand-bone))] px-6 py-3 rounded font-medium">
          Back to home
        </Link>
      </Section>
    </>
  );
}
